import React, { useEffect, useState, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { Helpers } from '../../../helpers/Helpers';
import { RootState } from '../../../redux/store';
import { MenuComponent } from '../../../_metronic/assets/ts/components';
import { KTCard } from '../../../_metronic/helpers/components/KTCard';
import { KTCardBody } from '../../../_metronic/helpers/components/KTCardBody';
import { KTIcon } from '../../../_metronic/helpers/components/KTIcon';
import Content from '../../../_metronic/layout/components/content/Content';
import { PageTitle } from '../../../_metronic/layout/core';
import toast from "react-hot-toast";
import { storeActivityIndicator, storeAreYouSureModalCallback } from '../../../redux/reducers/authSlice';
import { ServiceService } from '../../../services/ServiceService';
import { GetServiceListPagingAndFilterRequest, initialGetServiceListPagingAndFilterRequest } from '../../../models/request/service/GetServiceListPagingAndFilterRequest';
import TableFooter from '../../../components/TableFooter';
import { GetServiceListPagingAndFilterResponse, GetServiceListPagingAndFilterResponseData, GetServiceListPagingAndFilterResponseItem, initialGetServiceListPagingAndFilterResponseData } from '../../../models/response/service/GetServiceListPagingAndFilterResponse';
import { ColumnChooserModel } from '../../../models/common/ColumnChooserModel';
import { kolonlariBirlestir } from '../../../components/ColumnFilter/kolonBirlestir';
import { ToolbarWrapper } from '../../../_metronic/layout/components/toolbar';
import RefreshButton from '../../../components/RefreshButton';
import ServiceListFilters from './Components/ServiceListFilters';
import { ExportServiceListResponse } from '../../../models/response/service/ExportServiceListResponse';
import { DeleteServiceResponse } from '../../../models/response/service/DeleteServiceResponse';
import { useSortableColumns } from '../../../helpers/useSortableColumns';
import ColumnFilterRow from '../../../components/ColumnFilter/ColumnFilterRow';
import ColumnFilterChips from '../../../components/ColumnFilter/ColumnFilterChips';
import { ColumnFilterDefinitions } from '../../../components/ColumnFilter/ColumnFilterTypes';
import { loadConstants, YES_NO_FILTER } from '../../../components/ColumnFilter/columnFilterOptions';
import { ColumnFilterModel } from '../../../models/common/ColumnFilterModel';
import StatusBadge from '../../../components/StatusBadge';
import { buildExcelRequest, ExcelExportMode } from '../../../helpers/excelExportRequest';

const ServiceList = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const auth = useSelector((state: RootState) => state.auth)
    const pageName = "Ön Muhasebe > Tanımlamalar > Hizmet Kalemi Tanımları"
    const pageVersion = "1";
    const [data, setData] = useState<GetServiceListPagingAndFilterResponseData>(initialGetServiceListPagingAndFilterResponseData);
    const [filter, setFilter] = useState<GetServiceListPagingAndFilterRequest>(initialGetServiceListPagingAndFilterRequest)

    const getColumns = () => {
        var list: ColumnChooserModel[] = [];

        var str = localStorage.getItem(pageName + "-" + pageVersion + "-filters");

        list = [
            { title: 'Kod', name: 'code', order: 0, isVisible: true },
            { title: 'Ad', name: 'name', order: 0, isVisible: true },
            { title: 'Muhasebe Kodu', name: 'accountingCode', order: 0, isVisible: true },
            { title: 'Gelir', name: 'isIncome', order: 0, isVisible: true },
            { title: 'Gelir %', name: 'incomePercentageName', order: 0, isVisible: true },
            { title: 'Gider', name: 'isOutcome', order: 0, isVisible: true },
            { title: 'Gider %', name: 'outcomePercentageName', order: 0, isVisible: true },
            { title: 'Aktarım Tarihi', name: 'transferDateStr', order: 0, isVisible: true },
            { title: 'Aktif', name: 'isCustomActive', order: 0, isVisible: true },
            { title: 'Antrepo Giriş', name: 'isAntrepoIn', order: 0, isVisible: true },
            { title: 'Antrepo Çıkış', name: 'isAntrepoOut', order: 0, isVisible: true },
            { title: 'Hizmet Kalemi Miktar', name: 'needQuantity', order: 0, isVisible: true },
            { title: 'Tevkifat Uygulanır Mı?', name: 'isWithholding', order: 0, isVisible: true },
            { title: 'Oluşturan', name: 'createdUser', order: 0, isVisible: true },
            { title: 'Güncelleyen', name: 'updatedUser', order: 0, isVisible: true }
        ];

        for (var i = 0; i < list.length; i++) {
            list[i].order = i + 1;
        }

        return kolonlariBirlestir(list, str);
    }

    const [columns, setColumns] = useState<ColumnChooserModel[]>(getColumns());

    const performPagination = (i: number) => {
        getData({
            ...filter,
            currentPage: i,
            skip: (i - 1) * filter.take
        });
    }

    const changeTake = (_take: number) => {
        getData({
            ...filter,
            currentPage: 1,
            skip: 0,
            take: _take
        });
    }

    useEffect(() => {
        setTimeout(() => { MenuComponent.reinitialization() }, 1000)

        getData();
    }, [])

    const deleteService = async () => {
        try {
            var selectedIds = data.items.filter(x => x.isSelected).map(x => x.serviceId);

            dispatch(storeActivityIndicator(true))

            var response: DeleteServiceResponse = await ServiceService.deleteService(selectedIds);

            if (!response.isSuccess) {
                toast.error(response.message)
                dispatch(storeActivityIndicator(false))
                return;
            }

            toast.success(response.message)

            getData();
        } catch (error: any) {
            toast.error(error)
            dispatch(storeActivityIndicator(false))
        }
    }

    const updateService = async (_id: string | undefined = undefined) => {
        navigate('/service/listadd?id=' + (_id ? _id : data.items.filter(x => x.isSelected)[0].serviceId));
    }

    // Kolon filtresinde art arda istek gidebilir; yalnızca en son isteğin cevabı ekrana yazılır.
    const lastRequestNo = useRef(0);

    const getData = async (_filter: GetServiceListPagingAndFilterRequest | undefined = undefined) => {
        const requestNo = ++lastRequestNo.current;

        try {
            if (_filter)
                setFilter(_filter);
            else
                _filter = filter;

            dispatch(storeActivityIndicator(true))

            var response: GetServiceListPagingAndFilterResponse = await ServiceService.getServiceListPagingAndFilter(_filter);

            if (requestNo != lastRequestNo.current)
                return;

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            setData(response.data);
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            // Daha yeni bir istek sürüyorsa yükleniyor göstergesi açık kalır.
            if (requestNo == lastRequestNo.current)
                dispatch(storeActivityIndicator(false))
        }
    }

    const setItemSelected = (_id: string) => {
        setData({
            ...data,
            items: data.items.map(function (x) {
                if (x.serviceId == _id)
                    x.isSelected = !x.isSelected;
                return x;
            })
        })
    }

    const selectAll = () => {
        var isAllSelected = data.items.filter(x => x.companyId).length == data.items.filter(x => x.companyId && x.isSelected).length;

        setData({
            ...data,
            items: data.items.map(function (x) {
                if (x.companyId)
                    x.isSelected = !isAllSelected;

                return x;
            })
        })
    }

    const onSearchSubmit = (e: any) => {
        e.preventDefault()
        getData();
    }

    const excelExport = async (mode: ExcelExportMode) => {
        try {
            dispatch(storeActivityIndicator(true))

            var response: ExportServiceListResponse = await ServiceService.exportServiceList(buildExcelRequest(filter, mode, data.items.filter(x => x.isSelected).map(x => x.serviceId), columns));

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            window.location.href = Helpers.getEndpoint() + "/Excels/" + response.data;
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    // Başlığa tıklayarak sıralanabilen kolonlar.
    const sortableColumns = [
        'code', 'name', 'accountingCode',
        'isIncome', 'incomePercentageName', 'isOutcome', 'outcomePercentageName',
        'transferDateStr', 'isCustomActive', 'isAntrepoIn', 'isAntrepoOut',
        'needQuantity', 'isWithholding',
        'createdUser', 'updatedUser'
    ];

    const { thProps, sortArrow } = useSortableColumns(sortableColumns, filter, getData);

    // Kolon başlıklarının altındaki filtreler. Kolon adları backend'deki eşlemeyle
    // (ServiceManager.ApplyColumnFilters) aynı.
    const columnFilterDefinitions: ColumnFilterDefinitions = {
        code: { type: 'text' },
        name: { type: 'text' },
        accountingCode: { type: 'text' },
        isIncome: YES_NO_FILTER,
        incomePercentageName: { type: 'select', loadOptions: () => loadConstants('SERVICE_INCOME_OUTCOME_PERCENTAGE') },
        isOutcome: YES_NO_FILTER,
        outcomePercentageName: { type: 'select', loadOptions: () => loadConstants('SERVICE_INCOME_OUTCOME_PERCENTAGE') },
        transferDateStr: { type: 'date' },
        isCustomActive: YES_NO_FILTER,
        isAntrepoIn: YES_NO_FILTER,
        isAntrepoOut: YES_NO_FILTER,
        needQuantity: YES_NO_FILTER,
        isWithholding: YES_NO_FILTER,
        createdUser: { type: 'text' },
        updatedUser: { type: 'text' },
    };

    // Kolon filtresi değişince ilk sayfaya dönülür; sıralama ve sayfa boyu korunur.
    const changeColumnFilters = (columnFilters: ColumnFilterModel[]) => {
        getData({ ...filter, columnFilters: columnFilters, currentPage: 1, skip: 0 });
    }

    const getColumnValue = (item: GetServiceListPagingAndFilterResponseItem, column: string, index: number) => {
        if (column == "isCustomActive") {
            return (
                <td onClick={!item.companyId ? undefined : () => setItemSelected(item.serviceId)} onDoubleClick={!item.companyId ? undefined : () => updateService(item.serviceId)}><StatusBadge text={item.isCustomActive ? "Evet" : "Hayır"} /></td>
            )
        }
        else if (column == "isAntrepoIn") {
            return (
                <td onClick={!item.companyId ? undefined : () => setItemSelected(item.serviceId)} onDoubleClick={!item.companyId ? undefined : () => updateService(item.serviceId)}>{item.isAntrepoIn ? "Evet" : "Hayır"}</td>
            )
        }
        else if (column == "isAntrepoOut") {
            return (
                <td onClick={!item.companyId ? undefined : () => setItemSelected(item.serviceId)} onDoubleClick={!item.companyId ? undefined : () => updateService(item.serviceId)}>{item.isAntrepoOut ? "Evet" : "Hayır"}</td>
            )
        }
        else if (column == "needQuantity") {
            return (
                <td onClick={!item.companyId ? undefined : () => setItemSelected(item.serviceId)} onDoubleClick={!item.companyId ? undefined : () => updateService(item.serviceId)}>{item.needQuantity ? "Evet" : "Hayır"}</td>
            )
        }
        else if (column == "isWithholding") {
            return (
                <td onClick={!item.companyId ? undefined : () => setItemSelected(item.serviceId)} onDoubleClick={!item.companyId ? undefined : () => updateService(item.serviceId)}>{item.isWithholding ? "Evet" : "Hayır"}</td>
            )
        }
        else if (column == "isIncome") {
            return (
                <td onClick={!item.companyId ? undefined : () => setItemSelected(item.serviceId)} onDoubleClick={!item.companyId ? undefined : () => updateService(item.serviceId)}>{item.isIncome ? "Evet" : "Hayır"}</td>
            )
        }
        else if (column == "isOutcome") {
            return (
                <td onClick={!item.companyId ? undefined : () => setItemSelected(item.serviceId)} onDoubleClick={!item.companyId ? undefined : () => updateService(item.serviceId)}>{item.isOutcome ? "Evet" : "Hayır"}</td>
            )
        }
        else if (column == "createdUser") {
            return (
                <td onClick={!item.companyId ? undefined : () => setItemSelected(item.serviceId)} onDoubleClick={!item.companyId ? undefined : () => updateService(item.serviceId)}>{item.createdUser} - {item.createdDate}</td>
            )
        }
        else if (column == "updatedUser") {
            return (
                <td onClick={!item.companyId ? undefined : () => setItemSelected(item.serviceId)} onDoubleClick={!item.companyId ? undefined : () => updateService(item.serviceId)}>{item.updatedUser} - {item.updatedDate}</td>
            )
        }
        else {
            var item2: any = item;
            return <td onClick={!item.companyId ? undefined : () => setItemSelected(item.serviceId)} onDoubleClick={!item.companyId ? undefined : () => updateService(item.serviceId)}>{item2[column]}</td>;
        }
    }

    return (
        <React.Fragment>
            <ToolbarWrapper filters={<React.Fragment>
                <RefreshButton onClick={() => getData()} />
                <ServiceListFilters
                    columns={columns}
                    excelExport={excelExport}
                    getColumns={getColumns}
                    pageName={pageName}
                    pageVersion={pageVersion}
                    setColumns={setColumns}
                    filter={filter}
                    getData={getData}
                    setFilter={setFilter}
                    selectedCount={data.items.filter(x => x.isSelected).length}
                    deleteFunction={deleteService}
                    updateFunction={updateService}
                    onSearchSubmit={onSearchSubmit}
                />
            </React.Fragment>} />

            <PageTitle breadcrumbs={[{
                title: pageName.split('>').slice(0, pageName.split('>').length - 1).join(' > ') + ' > ',
                isActive: false,
                path: ''
            }]}>{(pageName.split('>')[pageName.split('>').length - 1])}</PageTitle>

            <Content>
                <KTCard className='mb-3'>
                    <KTCardBody className='py-2'>
                        <ColumnFilterChips
                            columns={columns}
                            definitions={columnFilterDefinitions}
                            filters={filter.columnFilters}
                            onChange={changeColumnFilters}
                        />

                        <div className='table-responsive new-table-container'>
                            <table id='kt_table_users' className='table align-middle table-row-dashed dataTable no-footer ebbe-compact-table'>
                                <thead>
                                    <tr className='text-start text-muted fw-bolder text-uppercase'>
                                        <th style={{ width: 1 }}>
                                            <div className='d-flex'>
                                                <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                    <input onChange={selectAll} className='form-check-input' type='checkbox' checked={data.items.filter(x => x.isSelected).length > 0 && data.items.filter(x => x.isSelected).length == data.items.filter(x => x.companyId).length} />
                                                </label>
                                            </div>
                                        </th>

                                        {
                                            columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order; }).map((item, index) =>
                                                <th {...thProps(item.name)}>
                                                    {item.title}
                                                    {sortArrow(item.name)}
                                                </th>
                                            )
                                        }
                                    </tr>

                                    <ColumnFilterRow
                                        columns={columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order; })}
                                        definitions={columnFilterDefinitions}
                                        filters={filter.columnFilters}
                                        onChange={changeColumnFilters}
                                        leadingCellCount={1}
                                    />
                                </thead>
                                <tbody className='text-gray-600 fw-bold'>
                                    {
                                        data.items.length == 0 && (
                                            <tr>
                                                <td className="text-center" colSpan={99}>Kayıt bulunamadı.</td>
                                            </tr>
                                        )
                                    }
                                    {
                                        data.items.map((item, index) =>
                                            <tr style={{ background: item.isSelected ? 'rgba(204, 204, 204, 0.25)' : undefined }}>
                                                <td style={{ width: 1 }}>
                                                    {
                                                        item.companyId && (
                                                            <div className='d-flex'>
                                                                <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                                    <input onChange={() => setItemSelected(item.serviceId)} className='form-check-input' type='checkbox' checked={item.isSelected} />
                                                                </label>
                                                            </div>
                                                        )
                                                    }
                                                </td>

                                                {
                                                    columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order }).map((column, columnIndex) => (
                                                        <React.Fragment>{getColumnValue(item, column.name, index)}</React.Fragment>
                                                    ))
                                                }
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </table>
                        </div>
                    </KTCardBody>

                    <TableFooter
                        changeTake={changeTake}
                        take={filter.take}
                        currentPage={filter.currentPage}
                        performPagination={performPagination}
                        totalPageCount={Math.ceil(data.totalRecordCount / filter.take)}
                        totalRecordCount={data.totalRecordCount}
                        selectedCount={data.items.filter(x => x.isSelected).length}
                    />
                </KTCard>
            </Content>
        </React.Fragment>
    )
}

export default ServiceList;